// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/process-pending-integration-calls-request-schema',
  type: 'object',
  required: [],
  properties: {
    integrationTaskId: {
      type: 'integer',
      nullable: true,
    },
    sourceAppSystemId: {
      type: 'integer',
      nullable: true,
    },
    itemsToBeProcessed: {
      type: 'integer',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
